import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    location: null,
    eventType: null,
    date: null,
    venue: null,
    time: null,
};

const eventFormSlice = createSlice({
    name: "form",
    initialState,
    reducers: {
        setEventFormData: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetEventFormData: () => initialState, 
    },
});

export const { setEventFormData, resetEventFormData } = eventFormSlice.actions;
export default eventFormSlice.reducer;
